import AuthService from "services/auth";
import GridPage from "components/layout/GridPage";
import useIsMobile from "components/hooks/useIsMobile";
import MemberDocument from "components/documents/MemberDocument";
import PublicDocumentWrapper from "components/documents/PublicDocumentWrapper";

export default () => {
  const currentUser = AuthService.getCurrentUser();
  const isMobile = useIsMobile();

  return currentUser ? (
    <GridPage
      sx={{
        maxWidth: "1000px",
        margin: isMobile ? "" : "auto",
        padding: isMobile ? "32px 24px" : "32px 48px",
        gap: "20px",
        paddingBottom: "0px",
      }}
    >
      <MemberDocument />
    </GridPage>
  ) : (
    <PublicDocumentWrapper />
  );
};
